"use client";

import React from "react";
import { Search } from "lucide-react";

interface GigFiltersProps {
    searchQuery: string;
    setSearchQuery: (q: string) => void;
    cadenceFilter: string;
    setCadenceFilter: (c: string) => void;
}

const CADENCES = [
    { value: "all", label: "All Times" },
    { value: "one_off", label: "One-Off" },
    { value: "ongoing", label: "Ongoing" },
    { value: "time_bound", label: "Time-Bound" },
    { value: "standby", label: "Standby" }
] as const;

export default function GigFilters({
    searchQuery,
    setSearchQuery,
    cadenceFilter,
    setCadenceFilter
}: GigFiltersProps) {
    return (
        <div className="bg-white border border-gray-150 rounded-xl p-4 shadow-sm flex flex-col gap-4 font-sans">
            {/* Search Input */}
            <div className="relative w-full">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search opportunities by title, group, or skill..."
                    className="w-full pl-11 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-xs sm:text-sm focus:outline-none focus:border-[#007a8a] focus:bg-white transition-all leading-normal placeholder:text-gray-300"
                />
            </div>

            {/* Sub-text */}
            <div className="text-[11.5px] text-gray-400">
                Filter by time commitment.
            </div>

            {/* Filter Rows Container */}
            <div className="flex flex-col gap-3.5">
                {/* Time Row */}
                <div className="flex items-center gap-3 flex-wrap">
                    <span className="font-sans font-bold text-[11px] uppercase tracking-[0.16em] text-[#007a8a] min-w-[70px]">
                        Time
                    </span>
                    <div className="flex flex-wrap gap-2">
                        {CADENCES.map((c) => (
                            <button
                                key={c.value}
                                onClick={() => setCadenceFilter(c.value)}
                                className={`px-[14px] py-[7px] rounded-full text-xs font-medium border transition-all cursor-pointer whitespace-nowrap ${
                                    cadenceFilter === c.value
                                        ? "bg-[#007a8a] border-[#007a8a] text-white shadow-sm"
                                        : "bg-white border-gray-200 text-gray-500 hover:text-gray-700 hover:border-gray-300"
                                }`}
                            >
                                {c.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

